// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__250Cg","insightsList":"newBusinessInsightsMenu_insightsList__19Dp9","active":"newBusinessInsightsMenu_active__31QQp"};